import { MDBCard, MDBCol, MDBRow } from 'mdbreact'

import Applicationidjson from '../../centers/ratings/applicationidjson'
import List from './list/list'
import Map from './map/mapcontainer'
import React from 'react'

function Views(props) {
  return (
    <MDBRow center>
      <MDBCol xs="12" md="8" lg="8" className="col-12">
        {/* Important! Always set the container height explicitly   */}
        <MDBCard
          className="SimpleMap my-2 p-1"
          style={{ height: '500px', width: '100%' }}
        >
          <Map
            //  Drupal data
            locations={props.locations}
            //  state valuess
            startPosition={props.startPosition}
            positionWindow={props.positionWindow}
            radius={props.radius}
            stateCheck={props.stateCheck}
            //  handlers
            searchtype={props.searchtype}
            handleRadiusChange={props.handleRadiusChange}
            handleToggleOpen={props.handleToggleOpen}
            handleToggleCloseAll={props.handleToggleCloseAll}
            //  starsdata
            allPracticemaxRatings={props.allPracticemaxRatings}
          />
        </MDBCard>
      </MDBCol>
      <MDBCol xs="12" md="4" lg="4" className="col-12">
        <List
          //  Drupal data
          locations={props.locations}
          //  state values
          startPosition={props.startPosition}
          positionWindow={props.positionWindow}
          //  handlers
          handleToggleOpen={props.handleToggleOpen}
          handleToggleCloseAll={props.handleToggleCloseAll}
          //  starsdata
          allPracticemaxRatings={props.allPracticemaxRatings}
          overridedistancesort={props.overridedistancesort}
        />
      </MDBCol>
      <Applicationidjson
        allPracticemaxRatings={props.allPracticemaxRatings}
        locationGroup={props.locationGroup}
      />
    </MDBRow>
  )
}

export default Views
